import { Form } from "react-bootstrap";

/**
 * JobTypeFilter - Checkbox filter for Job Types (CIC and RDT)
 * @param {Array} value - Selected type values
 * @param {Function} setValue - Setter for selected type values
 */
const JobTypeFilter = ({ value, setValue }) => {
  const handleCICChange = () => {
    const cicTypes = ["CIC", "CICM"];
    const hasCIC = cicTypes.some(type => value?.includes(type));

    if (hasCIC) {
      // Remove both if either is selected
      setValue(value?.filter((v) => !cicTypes.includes(v)));
    } else {
      // Add both if neither is selected
      setValue([...(value || []), ...cicTypes]);
    }
  };
  // Standard handler for other types
  const handleChange = (type) => {
    if (value?.includes(type)) {
      setValue(value?.filter((v) => v !== type));
    } else {
      setValue([...(value || []), type]);
    }
  };

  return (
    <div style={{ maxWidth: 220, display: "flex", alignItems: "center" }}>
      <Form.Group
        className="mb-3"
        controlId="jobTypeFilter"
        style={{ marginTop: 8, fontWeight: "bold", display: "flex", alignItems: "center", gap: 20 }}
      >
        <Form.Check
          type="checkbox"
          id="filter-cic"
          label="CIC/CICM"
          checked={value?.includes("CIC") || value?.includes("CICM")}
          onChange={handleCICChange}
          style={{ marginBottom: 0 }}
        />
        <Form.Check
          type="checkbox"
          id="filter-rdt"
          label="RDT"
          checked={value?.includes("RDT")}
          onChange={() => handleChange("RDT")}
          style={{ marginBottom: 0 }}
        />
      </Form.Group>
    </div>
  );
};

export default JobTypeFilter;
